<template>
  <b-select
    v-if="show && options.length > 1"
    :value="value"
    :options="options"
    value-field="column"
    text-field="name"
    class="mb-2"
    @input="$emit('input', $event)"
  />
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { FieldMapItem, FieldCalculationV2Config } from '@/types'

const props = {
  value: {
    type: String,
    required: true,
  },
  show: Boolean,
  options: {
    type: Array as PropType<(FieldMapItem | FieldCalculationV2Config)[]>,
    default: () => [],
  },
}

// eslint-disable-next-line no-use-before-define
@Component<FieldPicker>({
  watch: {
    selectFirstOption() {
      this.$emit('input', this.selectFirstOption)
    },
  },
})
export default class FieldPicker extends Vue.extend({ props }) {
  mounted() {
    // Pick the first option when mounted
    this.$emit('input', this.selectFirstOption)
  }

  get selectFirstOption() {
    const option = this.value && this.options.find(({ column }) => column === this.value)
    // If value is valid (ie exists in options, then do nothing)
    if (!option) {
      // Otherwise choose the first valid option or set to null
      if (this.options.length > 0) {
        return this.options[0].column
      } else {
        return ''
      }
    }
    return this.value
  }
}
</script>
